import { CandidateSearchForm as CandidateSearchFormValidator } from "@hireroo/validator";
import { zodResolver } from "@hookform/resolvers/zod";
import * as React from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import SearchForm, { SearchFormProps } from "../../modules/SearchForm/SearchForm";
import * as PrivateHelper from "./privateHelper";

export type CandidateSearchAreaProps = {
  disabled: boolean;
  defaultValues: CandidateSearchFormValidator.CandidateSearchQuerySchema;
  onChange: SubmitHandler<CandidateSearchFormValidator.CandidateSearchQuerySchema>;
  expectedSalaryField: PrivateHelper.ExpectedSalaryFieldArgs;
};

const CandidateSearchArea: React.FC<CandidateSearchAreaProps> = props => {
  const { onChange } = props;
  const validateSchema = CandidateSearchFormValidator.useCandidateSearchQuery();
  const methods = useForm<CandidateSearchFormValidator.CandidateSearchQuerySchema>({
    resolver: zodResolver(validateSchema),
    defaultValues: props.defaultValues,
  });
  const textFilterField = PrivateHelper.useTextFilterField();
  const expectedSalaryField = PrivateHelper.useExpectedSalaryField(props.expectedSalaryField);
  const jobChangeStatusesField = PrivateHelper.useJobChangeStatusesField();
  const averageScoreField = PrivateHelper.useAverageScoreField();
  const averageRankField = PrivateHelper.useAverageRankField();

  React.useEffect(() => {
    const subscriber = methods.watch(() => {
      methods.handleSubmit(onChange, console.warn)();
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [methods, onChange]);

  const searchFormProps: SearchFormProps = {
    kind: "MULTI_LINE",
    disabled: props.disabled,
    textFilter: textFilterField,
    fields: React.useMemo(
      () => [expectedSalaryField, jobChangeStatusesField, averageScoreField, averageRankField],
      [expectedSalaryField, jobChangeStatusesField, averageScoreField, averageRankField],
    ),
    onReset: () => {
      const resetValues: CandidateSearchFormValidator.CandidateSearchQuerySchema = {
        textFilter: "",
        expectedSalary: {
          min: props.expectedSalaryField.slider.min,
          max: props.expectedSalaryField.slider.max,
        },
        jobChangeStatuses: [],
        averageScore: {
          min: 0,
          max: 100,
        },
        averageRank: [],
      };
      methods.reset(resetValues);
    },
  };
  return (
    <FormProvider {...methods}>
      <SearchForm {...searchFormProps} />
    </FormProvider>
  );
};

CandidateSearchArea.displayName = "CandidateSearchArea";

export default CandidateSearchArea;
